import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class PanelRowTextConverter extends CmsConverterService<PanelRowTextData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      text: formData.st_panel_row_text ?? defaultTextInput,
    }
  }
}

export const PANEL_ROW_TEXT_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, PanelRowTextData>>('PanelRowTextConverter')

export interface PanelRowTextData extends ConvertedComponentData {
  text: TextInput;
}
